import { Box, Button, Typography, Modal, Grid } from "@mui/material";
import { ReactComponent as Joker } from "../../assets/dashboardIcons/JokerIcon.svg"
import UploadBack from "../../assets/dashboardIcons/uploadBg.jpg"

export default function Model({ open, setOpen, handleImageUpload, backImage, setBackImage, frontImage, setFrontImage, handleShow }) {


    return (
        <>
            <Modal className="etichettaModal" open={open} onClose={() => setOpen(false)}>
                <Box className="etichettaModal__inner">
                    {/* Left Side */}

                    <Box className='etichettaModal_row'>
                        <Box className='etichettaModal__leftContent'>
                            <Typography variant="h5" className="title">Etichetta</Typography>
                            <Typography variant="body2" className="subTitle">
                                Grazie al nostro tools di intelligenza artificiale potrai controllare se la tua etichetta è conforme alla normative vigente.
                            </Typography>
                            {/* <Box flexGrow={1} width="100%" bgcolor="grey.300" borderRadius={2}></Box> */}
                            <Box className='empatyBox'>
                                <span className="empatyBox__jokar"><Joker /></span>

                                <Button className="VerificaBtn" onClick={() => handleShow()} variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
                                    Verifica conformità etichetta
                                </Button>
                            </Box>

                        </Box>


                        <Box className='etichettaModal__rightContent'>

                            <Box className='etichettaModal__rightContent__uploadImages'>
                                <Box className='imageUploader'>
                                    {frontImage ? (
                                       <Box className='imageUploader__uploadedImgBox'>
                                          <img src={frontImage} alt="Front Label" width="100%"  />
                                       </Box>
                                    ) : (
                                        <Box className='imageUploader__box'>
                                            <img src={UploadBack} />
                                        </Box>
                                    )}
                                    <Box className='imageUploader__footer'>
                                    <Typography className="fonteText" variant="body2" >Fonte</Typography>
                                    {frontImage ? (
                                        <Button className="fonteText delete"  onClick={() => setFrontImage(null)}>Elimina</Button>
                                    ) : (
                                        <Button className="caricafile-label"
                                            variant="outlined"
                                            component="label">
                                            Carica File
                                            <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e, setFrontImage)} />
                                        </Button>
                                    )}
                                    </Box>
                                </Box>

                                <Box className='imageUploader'>
                                    {backImage ? (
                                        
                                        <Box className='imageUploader__uploadedImgBox'>
                                        <img src={backImage} alt="Back Label" width="100%" />
                                     </Box>
                                    ) : (
                                        <Box className='imageUploader__box'>
                                            <img src={UploadBack} />
                                        </Box>
                                    )}
                                    <Box className='imageUploader__footer'>
                                    <Typography className="fonteText">Retro</Typography>
                                    {backImage ? (
                                        <Button className="fonteText delete"  onClick={() => setBackImage(null)}>Elimina</Button>
                                    ) : (
                                        <Button className="caricafile-label"
                                            variant="outlined"
                                            component="label">
                                            Carica File
                                            <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e, setBackImage)} />
                                        </Button>
                                    )}
                                    </Box>
                                </Box>

                            </Box>
                        </Box>

                    </Box>

                </Box>
            </Modal>
        </>
    );
}
